import React from 'react';
import { ActionBadge } from './action-badge';
import { truncateUuid } from './util';
import { useParams } from 'react-router-dom';

export interface IClaimIdBadgeProps {
    className?: string;
    claimId: string;
    claimType?: string;
    forceClaim?: boolean;
    onCopy?: (url: string) => void;
    onRemove?: () => void;
    removeLabel?: string;
    openInNewTab?: boolean;
    Symbol?: React.ReactNode;
    children?: React.ReactNode;
}

export const ClaimIdBadge: React.FunctionComponent<IClaimIdBadgeProps> = (
    props: IClaimIdBadgeProps,
): React.ReactElement => {
    const { className, claimId, claimType, forceClaim, onCopy, onRemove, removeLabel, openInNewTab, Symbol, children } = props;
    const { accountId } = useParams<{ accountId: string }>();
    return (
        <ActionBadge
            className={className}
            hideAction={forceClaim}
            path={accountId ? `/${accountId}/claims/${claimId}` : `/claims/${claimId}`}
            tooltip="View Claim"
            onCopy={onCopy}
            onRemove={onRemove}
            removeLabel={removeLabel}
            openInNewTab={openInNewTab}
            Symbol={Symbol}>
            {children || `${claimType || ''} Claim ID – ${truncateUuid(claimId)}`}
        </ActionBadge>
    );
};
